import { MutationHookOptions, gql } from '@apollo/client';

import { IdProofingInput } from 'routes/marketplace-ede/types/ede/idVerify';
import { useEdeMutation, useEdeQueryName } from 'routes/marketplace-ede/context/edeQueryProvider';

type PostIdVerifyMutation = {
  postIdVerify: {
    identityProofingIdentifier: string;
    identityProofingChannelType: string;
  };
};

type PostIdVerifyMutationArgs = {
  personId: string;
  payload: IdProofingInput;
};

const queryType = 'POST_ID_VERIFY';

const usePostIdVerifyMutation = (
  options: MutationHookOptions<PostIdVerifyMutation, PostIdVerifyMutationArgs> = {},
) => {
  const queryName = useEdeQueryName(queryType);

  const POST_ID_VERIFY_MUTATION = gql`
    mutation PostIdVerify($personId: ID!, $payload: IdProofingInput!) {
      ${queryName} (personId: $personId, payload: $payload) {
        identityProofingChannelType
        identityProofingIdentifier
      }
    }
  `;

  return useEdeMutation<PostIdVerifyMutation, PostIdVerifyMutationArgs>(
    POST_ID_VERIFY_MUTATION,
    options,
    queryType,
  );
};

export default usePostIdVerifyMutation;
